import styled from "styled-components";
import { theme } from "@/styles/index";
import { ITextStylesProps } from "@/common/Text/Text.styles.types";
import { getFontSize } from "@/utils/style";


export const Text = styled.span<ITextStylesProps>`
  text-align:${({ align }) => align ? align : 'left'};
  font-weight:${({ fontFamily }) => fontFamily ? `${fontFamily.toLowerCase()}` : 'Vodafone Regular'};
  text-decoration:${({ textDecoration }) => textDecoration ? textDecoration : 'none'};
  color:${({ color }) => color ? color : theme.text.default};
  margin:${({ margin }) => margin ? margin : '0'};
  padding:${({ padding }) => padding ? padding : '0'};
  ${({ fontSize, responsive }) => responsive ? getFontSize(fontSize) : `font-size:${fontSize}px`};
  cursor:${({ cursor }) => cursor ? cursor : 'default'};
`;